<template>
  <custom-select
    :value="value"
    type="tree"
    url="NationRegionTree"
    :props="cascaderProps"
    :dataFilter="dataFilter"
    @input="onInput"
    ref="select"
    v-bind="$attrs"
    @getList="addressList = $event"
  ></custom-select>
</template>

<script>


export default {
  props: {
    // v-model
    value: {
      type: [Array, String],
      required: true
    },
    // 如果为true,会限制下拉框显示为：国，省，市。为false时，则不限制
    levelLimit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      cascaderProps: {
        label: 'name',
        value: 'code'
      },
      addressList: []
    };
  },
  methods: {
    onInput(val) {
      this.$emit('input', val);
      this.$emit('change', this.getAddressMsg(val));
    },
    dataFilter(list) {
      if (!this.levelLimit) {
        return list;
      }
      list.forEach((country) => {
        (country.children || []).forEach((province) => {
          (province.children || []).forEach((city) => {
            city.children = null;
          });
        });
      });
      return list;
    },
    // 根据当前value获取对应的地址信息：{country,countryCode,province,provinceCode,city,cityCode}
    getAddressMsg(val) {
      const value = val || this.value;
      const ret = {
        country: '',
        province: '',
        city: '',
        countryCode: '',
        provinceCode: '',
        cityCode: ''
      };
      if (value && value.length) {
        const addressList = this.addressList;
        const countryCode = value[0];
        const provinceCode = value[1];
        const cityCode = value[2];
        const country = addressList.find(item => item.code === countryCode);
        const province = country.children.find(item => item.code === provinceCode);
        const city = (province.children || []).find(item => item.code === cityCode);

        ret.country = country.name;
        ret.province = province.name;
        ret.city = city ? city.name : '';
        ret.countryCode = countryCode;
        ret.provinceCode = provinceCode;
        ret.cityCode = cityCode;
      }
      return ret;
    }
  }
};
</script>

<style></style>
